var two_years_ago = new Date().getFullYear() - 2 +'';
var last_year = new Date().getFullYear() - 1 + '';
var this_year = new Date().getFullYear() + '';
export default [
	{
		school_year: this_year
	},
	{
		school_year: last_year
	},
	{
		school_year: two_years_ago
	}
]
